/**
 * Constantes pour les messages à afficher dans la modale de demande de prms delestés
 */
export const MessagesDayInfo = {
  DAY_0_HOUR: '8h00',
  DAY_1_HOUR: '20h00',
  DAT_2_HOUR: '17h00',
  DAY_3_HOUR: '17h00',
  INFO_DAY_0: 'Pour information, le plan de délestage est mis à jour vers ',
  INFO_DAY_1_2: 'Pour information, le plan de délestage sera actualisé vers ',
  INFO_DAY_3: 'Pour information, le plan de délestage sera actualisé vers ',
  DESCRIPTION: 'Vous pourrez accéder uniquement aux données des compteurs de votre périmètre titulaire.',
  MSG_ATTENTION:
    'Attention :  un téléchargement peut produire un fichier vide si aucun de vos compteurs n’est impacté.',
};
